import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Problem } from '../components/sections/Problem';
import { Solution } from '../components/sections/Solution';
import { Features } from '../components/sections/Features';
import { Audience } from '../components/sections/Audience';
import { Pricing } from '../components/sections/Pricing';
import { Footer } from '../components/sections/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-charcoal-900 text-cream-100 selection:bg-amber-500/30 selection:text-amber-100" data-id="element-204">
      {/* Grain Overlay */}
      <div className="grain-overlay" data-id="element-205" />

      <main className="relative z-10" data-id="element-206">
        <Hero data-id="element-207" />
        <Problem data-id="element-208" />
        <Solution data-id="element-209" />
        <Features data-id="element-210" />
        <Audience data-id="element-211" />

        {/* Results Section - Small enough to be inline here or separate, let's keep it inline for simplicity as it's just a list */}
        <section className="py-12 md:py-16 bg-charcoal-800" data-id="element-212">
          <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-213">
            <h2 className="text-3xl font-serif text-cream-100 mb-12" data-id="element-214">
              Lo que vas a notar si lo haces en serio
            </h2>
            <div className="grid sm:grid-cols-2 gap-6 text-left" data-id="element-215">
              {['Menos hielo en la casa', "Más 'te veo' y menos 'solo existimos'", 'Más afecto pequeño sin agenda', 'Conversaciones más suaves (porque el clima mejora)', 'Intimidad que vuelve por escalones, no por presión', "Sensación de 'somos equipo' de nuevo"].map((item, i) => <div key={i} className="flex items-center gap-3 p-4 bg-charcoal-700/30 rounded-lg border border-charcoal-600/50" data-id="element-216">
                  <div className="w-2 h-2 rounded-full bg-amber-400" data-id="element-217" />
                  <span className="text-cream-200/90" data-id="element-218">{item}</span>
                </div>)}
            </div>
          </div>
        </section>

        <Pricing data-id="element-219" />
      </main>

      <Footer data-id="element-220" />
    </div>;
}